import { Api } from 'models/services/api';
import { UpdateIngredientCategoryQuery } from 'models/services/graphql';

import { IngredientCategoryData, IngredientCategoryDataToUpdate } from '../index';

type DataToUpdate = {
  id: string;
  input: IngredientCategoryDataToUpdate;
};

const RequestQuery = `
  mutation UpdateIngredientCategory($id: ID!, $input: IngredientCategoryUpdateInput!) {
    ${UpdateIngredientCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    updateIngredientCategory: IngredientCategoryData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: IngredientCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateIngredientCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };